export default __webpack_public_path__ + "static/070-39218cc244f3b773bc2a95160a077c76.jpg";